import {Button} from "antd";
import classNames from "classnames";

import React from "react";
import styles from "./index.less"

type TimeSlotSelectButtonProps ={
  slot: any,
  onClick: (slot) => void,
  onlyShowStart?: boolean,
  className?: string,
  /** Overlaid on the button (absolutely positioned), e.g. the customize-time badge. */
  extra?: React.ReactNode
}
const TimeSlotSelectButton = ({slot, onClick, onlyShowStart, className, extra}: TimeSlotSelectButtonProps) => {

  const getContent = () => {
    const start = slot.start.format('HH:mm')
    if (onlyShowStart)
      return start
    return `${start} - ${slot.end.format('HH:mm')}`
  }
  return <Button data-testid="timeslot-select-btn" onClick={() => onClick(slot)} className={classNames(styles.timeslotSelectButton, className)}>
    {getContent()}
    {extra}
  </Button>
}
export default TimeSlotSelectButton
